import { render, staticRenderFns } from "./EditableValueField.vue?vue&type=template&id=3b0b1dd2&scoped=true"
import script from "./EditableValueField.vue?vue&type=script&lang=js"
export * from "./EditableValueField.vue?vue&type=script&lang=js"
import style0 from "./EditableValueField.vue?vue&type=style&index=0&id=3b0b1dd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0b1dd2",
  null
  
)

export default component.exports